/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/source.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Source
 */
export interface Source {
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Source.Referrer referrer = 1;
     */
    referrer?: Source_Referrer;
    /**
     * @generated from protobuf field: optional string utm_campaign = 2;
     */
    utm_campaign?: string;
    /**
     * @generated from protobuf field: optional string utm_medium = 3;
     */
    utm_medium?: string;
    /**
     * @generated from protobuf field: optional string utm_source = 4;
     */
    utm_source?: string;
    /**
     * @generated from protobuf field: optional string utm_term = 5;
     */
    utm_term?: string;
    /**
     * @generated from protobuf field: optional string ftv_campaign = 6;
     */
    ftv_campaign?: string;
    /**
     * @generated from protobuf field: optional string referrer_url = 7;
     */
    referrer_url?: string;
    /**
     * @generated from protobuf field: optional bool deeplink_resolved_success = 8;
     */
    deeplink_resolved_success?: boolean;
    /**
     * @generated from protobuf field: optional string ftv_source = 9;
     */
    ftv_source?: string;
    /**
     * @generated from protobuf field: optional string ftv_term = 10;
     */
    ftv_term?: string;
    /**
     * @generated from protobuf field: optional string os_source = 11;
     */
    os_source?: string;
    /**
     * @generated from protobuf field: optional string media_type = 12;
     */
    media_type?: string;
}
/**
 * * External referrer that is tracked when page type is app_link.
 *
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.Source.Referrer
 */
export enum Source_Referrer {
    /**
     * * Used when fuboTV deep link opens from AppleTV app on AppleTV.
     *
     * @generated from protobuf enum value: apple_tv_app = 0;
     */
    apple_tv_app = 0,
    /**
     * * Used when fuboTV deep link opens from one of our partner or affiliate websites.
     * Some of the examples are:
     * 1. Google Search
     * 2. Affiliate partner websites
     * 3. Apple UMC
     *
     * @generated from protobuf enum value: partner = 1;
     */
    partner = 1,
    /**
     * * Used when fuboTV deep link opens from AppleTV topshelf experience.
     *
     * @generated from protobuf enum value: topshelf = 2;
     */
    topshelf = 2,
    /**
     * * Used when fuboTV deep link opens from AndroidTV home page Watch Next carousel.
     *
     * @generated from protobuf enum value: topshelf_continue_watching = 3;
     */
    topshelf_continue_watching = 3,
    /**
     * * Used when fuboTV deep link opens from AndroidTV home page fuboTV recommendations
     * carousel.
     *
     * @generated from protobuf enum value: topshelf_recommendations = 4;
     */
    topshelf_recommendations = 4,
    /**
     * * Used by deeplinks passed through different partner feeds: *
     *
     * @generated from protobuf enum value: feed_apple_umc = 5;
     */
    feed_apple_umc = 5,
    /**
     * @generated from protobuf enum value: feed_google_watch_actions = 6;
     */
    feed_google_watch_actions = 6,
    /**
     * @generated from protobuf enum value: feed_roku_sports_zone = 7;
     */
    feed_roku_sports_zone = 7,
    /**
     * @deprecated
     * @generated from protobuf enum value: feed_roku_vod = 8 [deprecated = true];
     */
    feed_roku_vod = 8,
    /**
     * @generated from protobuf enum value: feed_samsung_live = 9;
     */
    feed_samsung_live = 9,
    /**
     * @generated from protobuf enum value: feed_samsung_vod = 10;
     */
    feed_samsung_vod = 10,
    /**
     * @generated from protobuf enum value: feed_lg = 11;
     */
    feed_lg = 11,
    /**
     * @generated from protobuf enum value: feed_roku = 12;
     */
    feed_roku = 12,
    /**
     * @generated from protobuf enum value: feed_amazon_fire_tv = 13;
     */
    feed_amazon_fire_tv = 13,
    /**
     * @generated from protobuf enum value: feed_vizio_sports_zone = 14;
     */
    feed_vizio_sports_zone = 14,
    /**
     * @generated from protobuf enum value: feed_vizio_vod = 15;
     */
    feed_vizio_vod = 15,
    /**
     * @generated from protobuf enum value: feed_samsung_eden = 16;
     */
    feed_samsung_eden = 16
}
// @generated message type with reflection information, may provide speed optimized methods
class Source$Type extends MessageType<Source> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Source", [
            { no: 1, name: "referrer", kind: "enum", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.Source.Referrer", Source_Referrer] },
            { no: 2, name: "utm_campaign", kind: "scalar", localName: "utm_campaign", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "USA_General_Search_EN_GGL_Brand", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Campaign name." } },
            { no: 3, name: "utm_medium", kind: "scalar", localName: "utm_medium", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "CPC", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Medium Source." } },
            { no: 4, name: "utm_source", kind: "scalar", localName: "utm_source", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } },
            { no: 5, name: "utm_term", kind: "scalar", localName: "utm_term", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Typically search term." } },
            { no: 6, name: "ftv_campaign", kind: "scalar", localName: "ftv_campaign", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "In house parameter, its used for marking traffic originating from tv or radio or non digital campaigns." } },
            { no: 7, name: "referrer_url", kind: "scalar", localName: "referrer_url", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "www.example.com/path", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Full referrer url or, in case of an app_link event, the unparsed deep link URL." } },
            { no: 8, name: "deeplink_resolved_success", kind: "scalar", localName: "deeplink_resolved_success", opt: true, T: 8 /*ScalarType.BOOL*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "true", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "For a Source attached to an app_link event, whether or not the deeplink was well-formed; was the deeplink parsed and resolved successfully." } },
            { no: 9, name: "ftv_source", kind: "scalar", localName: "ftv_source", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "202412162114", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "First-party tracking parameter attached to deeplinks in partner feeds.  Used for identifying the time at which a partner integration data product was generated." } },
            { no: 10, name: "ftv_term", kind: "scalar", localName: "ftv_term", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "station_1234567", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "First-party tracking parameter attached to deeplinks in partner feeds. Used for marking specific content or channel of the deeplink." } },
            { no: 11, name: "os_source", kind: "scalar", localName: "os_source", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "search", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Parameter sent in the body of a deeplink resolution request, specifying the player- or platform-specific UI flow through which the deeplink was launched." } },
            { no: 12, name: "media_type", kind: "scalar", localName: "media_type", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "episode", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "secondary field from OS used to properly handle a deep_link url" } }
        ]);
    }
    create(value?: PartialMessage<Source>): Source {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Source>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Source): Source {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional fubo.tv.proto.common.v3.generic.Source.Referrer referrer */ 1:
                    message.referrer = reader.int32();
                    break;
                case /* optional string utm_campaign */ 2:
                    message.utm_campaign = reader.string();
                    break;
                case /* optional string utm_medium */ 3:
                    message.utm_medium = reader.string();
                    break;
                case /* optional string utm_source */ 4:
                    message.utm_source = reader.string();
                    break;
                case /* optional string utm_term */ 5:
                    message.utm_term = reader.string();
                    break;
                case /* optional string ftv_campaign */ 6:
                    message.ftv_campaign = reader.string();
                    break;
                case /* optional string referrer_url */ 7:
                    message.referrer_url = reader.string();
                    break;
                case /* optional bool deeplink_resolved_success */ 8:
                    message.deeplink_resolved_success = reader.bool();
                    break;
                case /* optional string ftv_source */ 9:
                    message.ftv_source = reader.string();
                    break;
                case /* optional string ftv_term */ 10:
                    message.ftv_term = reader.string();
                    break;
                case /* optional string os_source */ 11:
                    message.os_source = reader.string();
                    break;
                case /* optional string media_type */ 12:
                    message.media_type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Source, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional fubo.tv.proto.common.v3.generic.Source.Referrer referrer = 1; */
        if (message.referrer !== undefined)
            writer.tag(1, WireType.Varint).int32(message.referrer);
        /* optional string utm_campaign = 2; */
        if (message.utm_campaign !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.utm_campaign);
        /* optional string utm_medium = 3; */
        if (message.utm_medium !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.utm_medium);
        /* optional string utm_source = 4; */
        if (message.utm_source !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.utm_source);
        /* optional string utm_term = 5; */
        if (message.utm_term !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.utm_term);
        /* optional string ftv_campaign = 6; */
        if (message.ftv_campaign !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.ftv_campaign);
        /* optional string referrer_url = 7; */
        if (message.referrer_url !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.referrer_url);
        /* optional bool deeplink_resolved_success = 8; */
        if (message.deeplink_resolved_success !== undefined)
            writer.tag(8, WireType.Varint).bool(message.deeplink_resolved_success);
        /* optional string ftv_source = 9; */
        if (message.ftv_source !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.ftv_source);
        /* optional string ftv_term = 10; */
        if (message.ftv_term !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.ftv_term);
        /* optional string os_source = 11; */
        if (message.os_source !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.os_source);
        /* optional string media_type = 12; */
        if (message.media_type !== undefined)
            writer.tag(12, WireType.LengthDelimited).string(message.media_type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Source
 */
export const Source = new Source$Type();
